<template>
<div>
	<h3>Backlog</h3>
  <SimpleCrud
    :headers="headers"
    :name="rq_name"
    :scheme="scheme"
    :canDetail="false"
    
    >
    <!-- <template v-slot:creation_date="{ value }">
      <td>{{formalDateFormat(value)}}</td>
    </template> -->
    <!-- <template slot="crud-title">Política AIMS</template> -->
		<template slot="write-title">Editar</template>
    <template slot-scope="{ selectedItem }" slot="write">
				<in-text v-model="selectedItem.name" label="Nombre"/>
				<br>
				<in-file :value.sync="selectedItem.file" label="Archivo"/>
				<br>
        <br>
				<in-text v-model="selectedItem.bhp_url" label="Link Documento"/>
				<br>
				<fs1 tag="p" style="color:darkred" v-if="selectedItem.bhp_url">La vinculación de documentos por medio de un link ignorará el archivo cargado en plataforma.</fs1>
    </template>
  </SimpleCrud>
</div>
</template>

<script>
export default {
  data() {
    return {
      rq_name:'dashboard/backlog_report_list',
			scheme:{
				link:{ type:'file'},
				file:{ type:'file'},
			},
      headers:[
				{ text: '', value: 'actions', class:'width100px' },
				{ text: 'Nombre', value: 'name', class:'text_align_left' },
				/* { text: 'Fecha de Actualización', value: 'update_date' }, */
				/* { text: 'Fecha de vencimiento', value: 'due_date' }, */
				{ text: 'Archivo', value: 'link', class:'width100px' },
      ],
    };
  },
};
</script>



